var _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInquir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.438,1v98h73.5V1H12.438z M82.438,95.5h-66.5v-91h66.5V95.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.313,1l10.5,28h52.5l10.5-28H13.313z M72.813,25.5h-45.5l-7-21h59.5L72.813,25.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.938,99l-10.5-17.5h-52.5L12.438,99H85.938z M78.938,95.5h-59.5l7-10.5h45.5L78.938,95.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.938,
    y: 29,
    width: 7,
    height: 52.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquir);
export default __webpack_public_path__ + "static/media/inquir.9a98e4da9e61dc122a886b4eb9852da9.svg";
export { ForwardRef as ReactComponent };